<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">方案1信息</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" style="width:600px;">
        <el-form-item label="方案名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入方案名称" style="width:100%" />
        </el-form-item>
        <el-form-item label="提供运营商" prop="operatorOrgId">
          <el-select
            v-model="form.operatorOrgId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入搜索关键词"
            style="width:100%"
            :remote-method="selectOperatorOrgId"
          >
            <el-option v-for="item in OrgList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="价格类型" prop="type" >
                <el-radio-group v-model="form.type" @change="changeClick">
                    <el-radio :label="0" >原价</el-radio>
                    <el-radio :label="1" >优惠价</el-radio>
                </el-radio-group>
            </el-form-item> -->
        <el-form-item label="电费优惠" prop="electricity">
          <el-row>
            <el-col :span="10">
              <el-select v-model="form.electricityType" placeholder="请选择" @change="changeType">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-col>
            <el-col :span="1">&nbsp;&nbsp;</el-col>
            <el-col :span="10">
              <el-input
                v-model="form.electricity"
                placeholder="请输入"
                type="number" @blur="changeElecMoney(form2.electricity)"
              />
            </el-col>
            <el-col :span="3" style="text-align: center;">
              <div v-show="form.electricityType == 'fixed'">元</div>
              <div v-show="form.electricityType == 'discount'">%</div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="服务费优惠" prop="serviceFee">
          <el-row>
            <el-col :span="10">
              <el-select v-model="form.serviceFeeType" placeholder="请选择" @change="changeType2">
                <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-col>
            <el-col :span="1">&nbsp;&nbsp;</el-col>
            <el-col :span="10">
              <el-input
                v-model="form.serviceFee"
                placeholder="请输入"
                type="number" @blur="changeSerMoney(form2.electricity)"
              />
            </el-col>
            <el-col :span="3" style="text-align: center;">
              <div v-show="form.serviceFeeType == 'fixed'">元</div>
              <div v-show="form.serviceFeeType == 'discount'">%</div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="方案生效时间" prop="startTime">
          <el-row>
            <el-col :span="11">
              <el-date-picker
                v-model="form.startTime"
                type="date"
                placeholder="请选择日期"
                style="width:100%"
                value-format="yyyy-MM-dd"
              />
            </el-col>
            <el-col :span="2" style="text-align: center;">至</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.endTime"
                type="date"
                placeholder="请选择日期"
                style="width:100%"
                value-format="yyyy-MM-dd"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="font-size:12px;color: #00a6ff;">温馨提示：开始时间必填，结束时间非必填，如无结束时间则代表方案永久生效</div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-card>
    <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Xinzengrukoufangan',
  components: {},
  data() {
    return {
      form: {
        name: '',
        operatorOrgId: '',
        type: 0,
        electricityType: 'discount',
        electricity: 100,
        serviceFeeType: 'discount',
        serviceFee: 100,
        startTime: '',
        endTime: ''
      },
      options: [{
        value: 'discount',
        label: '电费折扣'
      }
        // {
        //     value:'fixed',
        //     label:"电费一口价"
        // }
      ],
      options2: [{
        value: 'discount',
        label: '服务费折扣'
      }
        // {
        //     value:'fixed',
        //     label:"服务费一口价"
        // }
      ],
      rules: {
        name: [{
          required: true,
          message: '请输入方案名称',
          trigger: 'blur'
        }],
        trafficOrgId: [{
          required: true,
          message: '请选择流量方',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择提供方',
          trigger: 'blur'
        }],
        operatorOrgId: [{
          required: true,
          message: '请选择运营商',
          trigger: 'blur'
        }],
        electricity: [{
          required: true,
          message: '请输入电费优惠',
          trigger: 'blur'
        }],
        serviceFee: [{
          required: true,
          message: '请输入服务费优惠',
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          message: '请选择开始时间',
          trigger: 'blur'
        }]
      },
      OrgList: []
    }
  },
  computed: {},
  mounted() {
    this.selectOperatorOrgId()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    changeType(val) {
      if (val == 'fixed') {
        this.form.electricity = ''
      } else {
        this.form.electricity = 100
      }
    },
    changeType2(val) {
      if (val == 'fixed') {
        this.form.serviceFee = ''
      } else {
        this.form.serviceFee = 100
      }
    },
    changeElecMoney(val) {
      if (this.form.electricityType == 'fixed') {
        if (val) {
          this.form.electricity = this.getFloat(val)
        }
      }
    },
    changeSerMoney(val) {
      if (this.form.serviceFeeType == 'fixed') {
        if (val) {
          this.form.serviceFee = this.getFloat(val)
        }
      }
    },
    checkCap(_value) {
      _value = _value.replace(/^(0+)|[^\d]+/g, '')
      this.form.trafficDay = _value
    },
    // changeClick(val) {
    //     if (val === 0) {
    //         this.isShow = false
    //     } else if (val === 1) {
    //         this.isShow = true
    //     }
    // },

    async save() {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.form.validate()
        ])
      } catch (error) {
        return
      }
      const data = {
        name: this.form.name,
        operatorOrgId: this.form.operatorOrgId,
        priceType: this.form.type,
        startTime: this.form.startTime,
        endTime: this.form.endTime,

        electricityType: this.form.electricityType,
        electricity: this.form.electricity,
        serviceFeeType: this.form.serviceFeeType,
        serviceFee: this.form.serviceFee
      }
      this.$store.dispatch('form/handle', {
        url: '/business/entrance',
        data: data,
        method: 'put',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success'
          })
          this.$router.go(-1)
        }
      })
    },

    cancel() {
      this.$router.go(-1)
    },
    selectOperatorOrgId(val) { // 提供运营商自动联想
      const data = {
        operatorName: val
      }
      this.$store.dispatch('form/handle', {
        url: '/business/entrance/getOperatorOrg',
        data: data,
        method: 'get',
        callback: (resp) => {
          this.OrgList = resp
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>



// WEBPACK FOOTER //
// src/views/flowScheme/addEntrance.vue